
<div class="fdimgnc">

</div>
 <div class="fdnc">

 </div>
 <div class="titfirstev">
    <img title="Wilout Pay" src="./assets/img/wilout_pay_logo_small.svg" width="40px">
    <br>
    Créez vous un compte gratuitement
</div>
<div class="blocedit blocnc" style="display:block">
  <div class="headedit" style="color:var(--ui-color-text)">
    Création de compte
  </div>
  <div class="labnc" style="margin-top:20px">Email</div>
  <input type="text" class="inncmail" placeholder="sample@sample.com">
  <div class="labnc">Mot de passe</div>
  <input type="text" class="inncpassword" placeholder="6 caractères minimum">
  <div class="labnc">Confimation du mot de passe</div>
  <input type="text" class="inncpasswordconf" placeholder="Confirmez la saisie">
  <div class="texterrorlog">

  </div>
  <div class="btncreate">
    <i class="far fa-user-circle"></i> &nbsp;Créer un compte
  </div>
  <div class="texttolog" routerLink="/login">
    Vous possédez déja un compte ?
    <br>
    Connectez-vous ici !
  </div>
</div>